var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 33 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_553_1775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3829 25.5209H9.82457C9.04844 25.5209 8.30411 25.1635 7.75531 24.5274C7.2065 23.8913 6.89819 23.0285 6.89819 22.1289V1.77714C6.89819 1.47727 6.79542 1.18968 6.61248 0.977646C6.42955 0.765607 6.18143 0.646484 5.92273 0.646484C5.66402 0.646484 5.41591 0.765607 5.23297 0.977646C5.05004 1.18968 4.94727 1.47727 4.94727 1.77714V22.1289C4.94881 23.6277 5.46317 25.0646 6.37751 26.1244C7.29184 27.1842 8.5315 27.7804 9.82457 27.7822H27.3829C27.6416 27.7822 27.8897 27.6631 28.0726 27.4511C28.2556 27.239 28.3583 26.9514 28.3583 26.6516C28.3583 26.3517 28.2556 26.0641 28.0726 25.8521C27.8897 25.64 27.6416 25.5209 27.3829 25.5209Z",
    fill: "#379DD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7997 23.2599C11.0584 23.2599 11.3065 23.1408 11.4894 22.9287C11.6724 22.7167 11.7751 22.4291 11.7751 22.1292V14.2146C11.7751 13.9148 11.6724 13.6272 11.4894 13.4151C11.3065 13.2031 11.0584 13.084 10.7997 13.084C10.541 13.084 10.2929 13.2031 10.1099 13.4151C9.92699 13.6272 9.82422 13.9148 9.82422 14.2146V22.1292C9.82422 22.4291 9.92699 22.7167 10.1099 22.9287C10.2929 23.1408 10.541 23.2599 10.7997 23.2599Z",
    fill: "#379DD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7031 11.9529V22.1288C14.7031 22.4287 14.8059 22.7163 14.9888 22.9283C15.1718 23.1404 15.4199 23.2595 15.6786 23.2595C15.9373 23.2595 16.1854 23.1404 16.3683 22.9283C16.5513 22.7163 16.654 22.4287 16.654 22.1288V11.9529C16.654 11.6531 16.5513 11.3655 16.3683 11.1534C16.1854 10.9414 15.9373 10.8223 15.6786 10.8223C15.4199 10.8223 15.1718 10.9414 14.9888 11.1534C14.8059 11.3655 14.7031 11.6531 14.7031 11.9529Z",
    fill: "#379DD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5781 15.3455V22.1294C19.5781 22.4293 19.6809 22.7169 19.8638 22.9289C20.0468 23.141 20.2949 23.2601 20.5536 23.2601C20.8123 23.2601 21.0604 23.141 21.2433 22.9289C21.4263 22.7169 21.529 22.4293 21.529 22.1294V15.3455C21.529 15.0456 21.4263 14.758 21.2433 14.546C21.0604 14.334 20.8123 14.2148 20.5536 14.2148C20.2949 14.2148 20.0468 14.334 19.8638 14.546C19.6809 14.758 19.5781 15.0456 19.5781 15.3455Z",
    fill: "#379DD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.457 10.8221V22.1286C24.457 22.4285 24.5598 22.7161 24.7427 22.9281C24.9257 23.1402 25.1738 23.2593 25.4325 23.2593C25.6912 23.2593 25.9393 23.1402 26.1222 22.9281C26.3052 22.7161 26.408 22.4285 26.408 22.1286V10.8221C26.408 10.5222 26.3052 10.2346 26.1222 10.0226C25.9393 9.81053 25.6912 9.69141 25.4325 9.69141C25.1738 9.69141 24.9257 9.81053 24.7427 10.0226C24.5598 10.2346 24.457 10.5222 24.457 10.8221Z",
    fill: "#379DD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7995 10.8222C11.0582 10.8221 11.3062 10.7029 11.4891 10.4909L14.9871 6.43635C15.173 6.23105 15.42 6.11654 15.6768 6.11654C15.9336 6.11654 16.1805 6.23105 16.3664 6.43635L18.4851 8.89213C19.0339 9.52803 19.7781 9.88525 20.5541 9.88525C21.3301 9.88525 22.0743 9.52803 22.623 8.89213L28.072 2.57629C28.2496 2.36305 28.348 2.07744 28.3457 1.78099C28.3435 1.48453 28.2409 1.20095 28.0601 0.991318C27.8792 0.781685 27.6346 0.662775 27.3788 0.660199C27.123 0.657623 26.8766 0.771587 26.6926 0.977545L21.2437 7.29226C21.0608 7.50422 20.8127 7.6233 20.5541 7.6233C20.2954 7.6233 20.0474 7.50422 19.8644 7.29226L17.7457 4.8376C17.1969 4.20171 16.4527 3.84448 15.6768 3.84448C14.9008 3.84448 14.1566 4.20171 13.6078 4.8376L10.1098 8.89213C9.97344 9.05026 9.88057 9.2517 9.84295 9.47099C9.80533 9.69029 9.82465 9.91759 9.89846 10.1242C9.97227 10.3307 10.0973 10.5073 10.2576 10.6315C10.418 10.7558 10.6066 10.8221 10.7995 10.8222Z",
    fill: "#379DD0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_553_1775",
    x: 0.947266,
    y: 0.646484,
    width: 31.4102,
    height: 35.1357,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_553_1775"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_553_1775",
    result: "effect2_dropShadow_553_1775"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_553_1775",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg1);
export default __webpack_public_path__ + "static/media/svg1.86242237ff8935c4a289a3b403e96509.svg";
export { ForwardRef as ReactComponent };